import { DateRangeTab } from "../../../../../../../components/general/DateRangeInput/constants.ts";
import { determineRangeInfo, parseDate } from "../../../../../../../components/general/DateRangeInput/utils/dateRangeUtils.ts";
import type { VATDeclarationApprovalStatus } from "../../../../../../../generated/enums.ts";

export type VatReturnSaveBlockReason =
    | 'not_generated'
    | 'draft_refreshing'
    | 'not_month_or_quarter'
    | 'period_not_ended'
    | 'approval_status_loading'
    | 'approval_status_unavailable'
    | 'awaiting_approval'
    | 'approved';

const SAVE_BLOCK_REASON_BY_APPROVAL_STATUS: Record<VATDeclarationApprovalStatus, VatReturnSaveBlockReason | null> = {
    pending: 'awaiting_approval',
    approved: 'approved',
    rejected: null,
    withdrawn: null,
};

export function getVatReturnSaveBlockReason({
    hasGeneratedDeclaration,
    isRefreshingDeclaration,
    dateFrom,
    dateTo,
    today,
    approvalStatus,
    isLoadingApprovalStatus,
    hasApprovalStatusLoadError,
}: {
    hasGeneratedDeclaration: boolean;
    isRefreshingDeclaration: boolean;
    dateFrom: string;
    dateTo: string;
    today: string;
    approvalStatus: VATDeclarationApprovalStatus | null;
    isLoadingApprovalStatus: boolean;
    hasApprovalStatusLoadError: boolean;
}): VatReturnSaveBlockReason | null {
    if (!hasGeneratedDeclaration || !dateFrom || !dateTo) {
        return 'not_generated';
    }
    if (isRefreshingDeclaration) {
        return 'draft_refreshing';
    }
    const { tab } = determineRangeInfo({ from: parseDate(dateFrom), to: parseDate(dateTo) });
    if (tab !== DateRangeTab.Month && tab !== DateRangeTab.Quarter) {
        return 'not_month_or_quarter';
    }
    if (dateTo >= today) {
        return 'period_not_ended';
    }
    if (isLoadingApprovalStatus) {
        return 'approval_status_loading';
    }
    if (hasApprovalStatusLoadError) {
        return 'approval_status_unavailable';
    }
    return approvalStatus === null ? null : SAVE_BLOCK_REASON_BY_APPROVAL_STATUS[approvalStatus];
}
